import { create } from 'zustand'

import { CreateTaskInitialData } from '@/feature/execution-board'

export interface CreateTaskModalStore {
  isOpen: boolean
  initialData?: CreateTaskInitialData
  openModal: (initialData?: CreateTaskInitialData) => void
  closeModal: () => void
}

export const useCreateTaskModalStore = create<CreateTaskModalStore>((set) => ({
  isOpen: false,
  initialData: undefined,

  openModal: (initialData?: CreateTaskInitialData) => {
    set({
      isOpen: true,
      initialData,
    })
  },

  closeModal: () => {
    set({
      isOpen: false,
      initialData: undefined,
    })
  },
}))
